import * as React from 'react';
import { DataTestObject, buildDataTest } from '../../../utilities/testAutomation';

interface SwitchInputProps {
  options: string[];
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  dataTest?: DataTestObject;
}

export const SwitchInput = ({
  options,
  name,
  value,
  onChange,
  dataTest,
}: SwitchInputProps) => (
  <div className="input-wrapper">
    <div className="switch">
      {options.map(option => (
        <button
          className="radio-label"
          role="option"
          key={option}
          aria-selected={value === option}
          name={name}
          value={option}
          onClick={onChange}
          {...buildDataTest(dataTest, option)}
        >
          {option}
        </button>
      ))}
    </div>
  </div>
);

export default SwitchInput;



// WEBPACK FOOTER //
// ./src/components/Inputs/SwitchInput/SwitchInput.tsx